import type { EntityConfig } from '../types'

export const eventEntity: EntityConfig = {
  id: 'event',
  displayName: 'Event',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'received', label: 'Received' },
      { value: 'processed', label: 'Processed' },
      { value: 'failed', label: 'Failed' },
    ],
    options: [
      { value: 'received', label: 'Received', color: 'pending' },
      { value: 'processed', label: 'Processed', color: 'success' },
      { value: 'failed', label: 'Failed', color: 'error' },
    ],
    mappings: {
      all: ['received', 'processed', 'failed'],
      received: ['received'],
      processed: ['processed'],
      failed: ['failed'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'status',
    'dateRange',
    'search',
  ]
}
